import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const list = [
	{ name: 'Get a User', link: 'get-user' },
	{ name: 'Get a Post', link: 'get-post' },
	{ name: 'Upload a Profile Image', link: 'upload-profile-image' },
	{ name: 'Upload a Video', link: 'upload-video' },
	{ name: 'Preregister a User', link: 'preregister-user' },
	{ name: 'Update a User', link: 'update-user' },
	{ name: 'Share a Post', link: 'share-post' },
	{ name: 'Manage Targets', link: 'manage-targets' },
];
class SimpleTasksDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select(event) {
		this.props.dispatch(push('/getting-started/simple-tasks/' + event.target.value));
	}

	render() {
		const ItemLinks = list.sort((a, b) => a.name > b.name).map((item, index) =>
			<option key={index} name={item.name} value={item.link}>{item.name}</option>
		);
		return (
			<div className='dropdown-container'>
				<select className='dropdown-list' onChange={this.select}>
					{ItemLinks}
				</select>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;

	if (match) {
		const pathLink = match.path;

		return {
			selectedName: pathLink
		};
	}

	return {};
};

SimpleTasksDropdown.propTypes = {
	dispatch: PropTypes.func.isRequired
};


export default withRouter(connect(mapStateToProps)(SimpleTasksDropdown));


// WEBPACK FOOTER //
// ./src/components/getting-started/SimpleTasksDropdown.js